var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('demo-banner'),_c('router-view'),_c('vue-progress-bar'),_c('notifications',{attrs:{"position":"bottom right"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }